import {QueueItemType} from "../../types";

export interface QueueItemLinkProps {
    data: QueueItemType;
}

export default function QueueItemText({data}: QueueItemLinkProps) {
    if (!data?.metadata?.text) return null;

    return (
        <div className="w-full bg-dark-black p-4 break-words max-w-[100%]">
            {data.metadata.text}
        </div>
    );
}